export const TOTAL_DURATION_NULL = '^(?:(?:(00):)?(00):)?(00)$';
